module.exports = __webpack_public_path__ + "img/haut.a5ca896.svg";